export default [
  {
    path: "/projects",
    name: "Projects",
    component: () => import("../../views/Projects/ProjectList")
  },
  {
    path: "/project/new",
    name: "ProjectNew",
    component: () => import("../../views/Projects/ProjectNew")
  },
  {
    path: "/project/edit/:uuid",
    name: "ProjectEdit",
    props: true,
    component: () => import("../../views/Projects/ProjectEdit")
  },
  {
    path: "/projects/view/:uuid",
    name: "ProjectView",
    props: true,
    component: () => import("../../views/Projects/ProjectView")
  },
  {
    path: "/project/pictures/:uuid",
    name: "ProjectPictures",
    props: true,
    component: () => import("../../views/Projects/ProjectPictures")
  },
  {
    path: "/projects/view/:uuid/contacts",
    name: "ProjectViewContacts",
    props: true,
    component: () => import("../../views/Projects/ProjectViewContacts")
  }
];
